module.exports = __webpack_public_path__ + "img/collection-memoireRingsBestseller@2x.083d6fa.webp";